import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Form, FormGroup, Label } from "reactstrap";
import {
  createSupplierSimplifiedInvoice,
  getDeductionList,
  getDeliveryMethodList,
  getDocumentSetList,
  getListCountry,
  getListCurrency,
  getListMainproduct,
  getMoloniVehiclesList,
  getTaxList,
  viewSupplierSimplifiedInvoices,
  updateSupplierSimplifiedInvoice,
  getMaturityDatesList,
  getDeliveryNotesList,
  getListSupplierList,
  getPaymentMethodList,
  getPurchaseorderList,
  getWaybillsList,
  getBillLandingList,
} from "../../services/MoloniServices";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { getCommonSearchList } from "../../services/settingsServices";

const AddSupplierSimplifiedInvoices = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);
  const initialTax = { tax_id: 0, value: 0, order: 0, cumulative: 0 };
  const initialChildProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const initialProduct = {
    product_id: 0,
    name: "",
    summary: "",
    qty: 0,
    price: 0,
    discount: 0,
    deduction_id: null,
    order: 0,
    exemption_reason: "",
    warehouse_id: null,
    taxes: [initialTax],
  };

  const [supplierSimplifiedInvoicesData, setSupplierSimplifiedInvoicesData] =
    useState({
      id: "",
      moloni_id: "",
      date: new Date().toISOString().split("T")[0],
      document_set_id: "",
      customer_id: "",
      your_reference: "",
      our_reference: "",
      supplier_id: "",
      related_documents_notes: "",
      products: [initialProduct],
      exchange_currency_id: "",
      exchange_rate: "",
      delivery_method_id: "",
      delivery_datetime: "",
      delivery_departure_address: "",
      delivery_departure_city: "",
      delivery_departure_zip_code: "",
      delivery_departure_country: "",
      delivery_destination_address: "",
      delivery_destination_city: "",
      delivery_destination_zip_code: "",
      delivery_destination_country: "",
      vehicle_id: "",
      vehicle_name: "",
      vehicle_number_plate: "",
      notes: "",
      status: 0,
      financial_discount: "",
      expiration_date: new Date().toISOString().split("T")[0],
      maturity_date_id: "",
      special_discount: "",
      associate_document_type: "",
      associated_documents: [],
      payments: [],
    });

  const [
    supplierSimplifiedInvoicesViewData,
    setSupplierSimplifiedInvoicesViewData,
  ] = useState("");
  let errorsObj = {
    date: "",
    document_set_id: "",
    expiration_date: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [vehiclesList, setVehiclesList] = useState([]);
  const [propertyErrors, setPropertyErrors] = useState([]);
  const [exchangeCurrList, setExchangeCurrList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [deductionList, setDeductionList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);
  const [assocDataList, setAssocDataList] = useState([]);
  const [errorsPro, setErrorsPro] = useState({});
  const [selectedProduct, setSelectedProduct] = useState("");
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [maturityDataList, setMaturityDataList] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);
  const [suppliersDataList, setSuppliersDataList] = useState([]);
  const [paymentErrors, setPaymentErrors] = useState([]);
  const [paymentList, setPaymentList] = useState([]);

  const [exemptionList, setExemptionList] = useState([]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "exception_list",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].description,
          });
        }

        setExemptionList(list);
      })
      .catch((err) => {});
  }, []);

  const validateProduct = (product, index) => {
    let newErrors = {};

    if (!product.product_id) newErrors.product_id = "Product is required";
    if (!product.name?.trim()) newErrors.name = "Name is required";
    if (!product.qty || product.qty <= 0)
      newErrors.qty = "Quantity is required";
    if (!product.price || product.price <= 0)
      newErrors.price = "Price is required";

    setErrorsPro((prev) => ({
      ...prev,
      [index]: newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };

  const handleAddProduct = (e) => {
    e.preventDefault();

    let list = [...supplierSimplifiedInvoicesData.products];
    list.push({ ...initialProduct });

    setSupplierSimplifiedInvoicesData({
      ...supplierSimplifiedInvoicesData,
      products: list,
    });
  };

  const handleRemoveProduct = (e, index) => {
    e.preventDefault();

    let list = [...supplierSimplifiedInvoicesData.products];
    list.splice(index, 1);

    setSupplierSimplifiedInvoicesData({
      ...supplierSimplifiedInvoicesData,
      products: list,
    });
  };

  const handleAddChildProduct = (e, productIndex) => {
    e.preventDefault();
    let list = [...supplierSimplifiedInvoicesData.products];
    if (!list[productIndex].child_products) {
      list[productIndex].child_products = [];
    }
    list[productIndex].child_products.push({ ...initialChildProduct });
    setSupplierSimplifiedInvoicesData({
      ...supplierSimplifiedInvoicesData,
      products: list,
    });
  };

  const handleRemoveChildProduct = (e, productIndex, childIndex) => {
    e.preventDefault();
    let list = [...supplierSimplifiedInvoicesData.products];
    list[productIndex].child_products.splice(childIndex, 1);
    setSupplierSimplifiedInvoicesData({
      ...supplierSimplifiedInvoicesData,
      products: list,
    });
  };

  const handleAddChildProperty = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...supplierSimplifiedInvoicesData.products];

    if (!list[productIndex].child_products[childIndex].properties) {
      list[productIndex].child_products[childIndex].properties = [];
    }

    list[productIndex].child_products[childIndex].properties.push({
      title: "",
      value: "",
    });

    setSupplierSimplifiedInvoicesData({
      ...supplierSimplifiedInvoicesData,
      products: list,
    });
  };

  const handleAddChildTax = (e, productIndex, childIndex) => {
    e.preventDefault();

    let list = [...supplierSimplifiedInvoicesData.products];

    if (!list[productIndex].child_products[childIndex].taxes) {
      list[productIndex].child_products[childIndex].taxes = [];
    }

    list[productIndex].child_products[childIndex].taxes.push({
      tax_id: null,
      value: 0,
      order: null,
      cumulative: 0,
    });

    setSupplierSimplifiedInvoicesData({
      ...supplierSimplifiedInvoicesData,
      products: list,
    });
  };

  const handleAddTax = (e, productIndex) => {
    e.preventDefault();

    let list = [...supplierSimplifiedInvoicesData.products];
    list[productIndex].taxes.push({ ...initialTax });

    setSupplierSimplifiedInvoicesData({
      ...supplierSimplifiedInvoicesData,
      products: list,
    });
  };

  const handleRemoveTax = (e, productIndex, taxIndex) => {
    e.preventDefault();

    let list = [...supplierSimplifiedInvoicesData.products];
    list[productIndex].taxes.splice(taxIndex, 1);

    setSupplierSimplifiedInvoicesData({
      ...supplierSimplifiedInvoicesData,
      products: list,
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSupplierList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSuppliersDataList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeliveryMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeliveryMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (uuid) {
      let data = { id: uuid };
      viewSupplierSimplifiedInvoices(data)
        .then((response) => {
          setSupplierSimplifiedInvoicesViewData(response.data.data);
        })
        .catch((err) => {
          navigate("/supplierSimplifiedInvoices");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(() => {
    if (supplierSimplifiedInvoicesViewData) {
      setSupplierSimplifiedInvoicesData({
        id: supplierSimplifiedInvoicesViewData?.id,
        date: supplierSimplifiedInvoicesViewData?.date,
        document_set_id: supplierSimplifiedInvoicesViewData?.document_set_id,
        your_reference: supplierSimplifiedInvoicesViewData?.your_reference,
        related_documents_notes:
          supplierSimplifiedInvoicesViewData?.related_documents_notes,
        products: supplierSimplifiedInvoicesViewData?.products,
        exchange_currency_id:
          supplierSimplifiedInvoicesViewData?.exchange_currency_id,
        exchange_rate: supplierSimplifiedInvoicesViewData?.exchange_rate,
        delivery_method_id:
          supplierSimplifiedInvoicesViewData?.delivery_method_id,
        delivery_datetime:
          supplierSimplifiedInvoicesViewData?.delivery_datetime,
        delivery_departure_city:
          supplierSimplifiedInvoicesViewData?.delivery_departure_city,
        delivery_departure_zip_code:
          supplierSimplifiedInvoicesViewData?.delivery_departure_zip_code,
        delivery_departure_country:
          supplierSimplifiedInvoicesViewData?.delivery_departure_country,
        delivery_destination_address:
          supplierSimplifiedInvoicesViewData?.delivery_destination_address,
        delivery_destination_city:
          supplierSimplifiedInvoicesViewData?.delivery_destination_city,
        delivery_destination_zip_code:
          supplierSimplifiedInvoicesViewData?.delivery_destination_zip_code,
        delivery_destination_country:
          supplierSimplifiedInvoicesViewData?.delivery_destination_country,
        vehicle_id: supplierSimplifiedInvoicesViewData?.vehicle_id,
        vehicle_name: supplierSimplifiedInvoicesViewData?.vehicle_name,
        vehicle_number_plate:
          supplierSimplifiedInvoicesViewData?.vehicle_number_plate,
        notes: supplierSimplifiedInvoicesViewData?.notes,
        status: supplierSimplifiedInvoicesViewData?.status,
        financial_discount:
          supplierSimplifiedInvoicesViewData?.financial_discount,
        delivery_departure_address:
          supplierSimplifiedInvoicesViewData?.delivery_departure_address,
        expiration_date: supplierSimplifiedInvoicesViewData?.expiration_date,
        maturity_date_id: supplierSimplifiedInvoicesViewData?.maturity_date_id,
        our_reference: supplierSimplifiedInvoicesViewData?.our_reference,
        special_discount: supplierSimplifiedInvoicesViewData?.special_discount,
        associated_documents:
          supplierSimplifiedInvoicesViewData?.associated_documents,
        associate_document_type:
          supplierSimplifiedInvoicesViewData?.associate_document_type,
        supplier_id: supplierSimplifiedInvoicesViewData?.supplier_id,
        payments: supplierSimplifiedInvoicesViewData?.payments,
      });
    }
  }, [supplierSimplifiedInvoicesViewData]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getPaymentMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setPaymentList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleAddAssociatedDocuments = () => {
    setSupplierSimplifiedInvoicesData((prev) => {
      const lastAssociatedDocuments =
        prev.associated_documents[prev.associated_documents?.length - 1];

      if (!lastAssociatedDocuments) {
        return {
          ...prev,
          associated_documents: [{ associated_id: "", value: "" }],
        };
      }

      if (
        !lastAssociatedDocuments.associated_id ||
        !lastAssociatedDocuments.value
      ) {
        toast.error(
          "Please complete associate,value before adding another associated documents",
        );
        return prev;
      }

      return {
        ...prev,
        associated_documents: [
          ...prev.associated_documents,
          { associated_id: "", value: "" },
        ],
      };
    });
  };

  const handleRemoveAssociatedDocuments = (index) => {
    setSupplierSimplifiedInvoicesData((prev) => ({
      ...prev,
      associated_documents: prev.associated_documents.filter(
        (_, i) => i !== index,
      ),
    }));
  };

  const handleChangeAssociatedDocuments = (index, field, value) => {
    setSupplierSimplifiedInvoicesData((prev) => {
      const updatedDocs = [...prev.associated_documents];

      if (field === "associated_id") {
        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc && selectedDoc.net_value) {
          updatedDocs[index].value = selectedDoc.net_value;
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, associated_documents: updatedDocs };
    });

    setPropertyErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "associated_id" && !value) {
        errors[index].associated_id = "Associated is required";
      } else if (field === "associated_id") {
        errors[index].associated_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      return errors;
    });
  };

  const handleAddPayments = () => {
    setSupplierSimplifiedInvoicesData((prev) => {
      const lastPayments = prev.payments[prev.payments?.length - 1];

      if (!lastPayments) {
        return {
          ...prev,
          payments: [{ payment_method_id: "", date: "", value: "", notes: "" }],
        };
      }

      if (
        !lastPayments.payment_method_id ||
        !lastPayments.value ||
        !lastPayments.date
      ) {
        toast.error(
          "Please complete payment method,value date, before adding another payment.",
        );
        return prev;
      }

      return {
        ...prev,
        payments: [
          ...prev.payments,
          { payment_method_id: "", date: "", value: "" },
        ],
      };
    });
  };

  const handleRemovePayments = (index) => {
    setSupplierSimplifiedInvoicesData((prev) => ({
      ...prev,
      payments: prev.payments.filter((_, i) => i !== index),
    }));
  };

  const handleChangePayments = (index, field, value) => {
    setSupplierSimplifiedInvoicesData((prev) => {
      const updatedDocs = [...prev.payments];

      if (field === "payment_method_id") {
        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc && selectedDoc.net_value) {
          updatedDocs[index].value = selectedDoc.net_value;
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, payments: updatedDocs };
    });

    setPaymentErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "payment_method_id" && !value) {
        errors[index].associated_id = "Payment Method is required";
      } else if (field === "payment_method_id") {
        errors[index].payment_method_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      if (field === "date" && !value) {
        errors[index].date = "Date is required";
      } else if (field === "date") {
        errors[index].date = "";
      }

      return errors;
    });
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (!supplierSimplifiedInvoicesData?.customer_id) {
      return;
    }

    if (Number(supplierSimplifiedInvoicesData.associate_document_type) === 1) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: supplierSimplifiedInvoicesData.customer_id,
      };

      getDeliveryNotesList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }

    if (Number(supplierSimplifiedInvoicesData.associate_document_type) === 5) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: supplierSimplifiedInvoicesData.customer_id,
      };

      getBillLandingList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }

    if (Number(supplierSimplifiedInvoicesData.associate_document_type) === 6) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: supplierSimplifiedInvoicesData.customer_id,
      };

      getWaybillsList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }

    if (Number(supplierSimplifiedInvoicesData.associate_document_type) === 7) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: supplierSimplifiedInvoicesData.customer_id,
      };

      getPurchaseorderList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }
  }, [
    supplierSimplifiedInvoicesData,
    supplierSimplifiedInvoicesData?.associate_document_type,
  ]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeductionList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeductionList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListMainproduct(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
            price: response.data[i].price,
            stock: response.data[i].stock,
            exemption_reason: response.data[i].exemption_reason,
            taxes: response.data[i].taxes,
            properties: response.data[i].properties,
            warehouse: response.data[i].warehouse,
          });
        }

        setProductList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (selectedProduct) {
      const initialProduct = {
        product_id: selectedProduct?.value,
        name: selectedProduct.label || "",
        summary: "",
        qty: selectedProduct.stock || 0,
        price: selectedProduct.price || 0,
        discount: 0,
        deduction_id: "",
        order: 0,
        exemption_reason: "",
        warehouse_id: selectedProduct.warehouse,
        properties: selectedProduct.properties || [],
        taxes: selectedProduct.taxes || [],
      };

      setSupplierSimplifiedInvoicesData((prev) => ({
        ...prev,
        products: [initialProduct],
      }));
    }
  }, [selectedProduct]);

  useEffect(function () {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      type: "m_invoice",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setInvoiceType(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCurrency(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setExchangeCurrList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMoloniVehiclesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].description,
          });
        }

        setVehiclesList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    setBtnLoader(true);

    let error = false;
    let errorObj = { ...errorsObj };
    if (!supplierSimplifiedInvoicesData?.date) {
      errorObj.date = `Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!supplierSimplifiedInvoicesData.expiration_date) {
      errorObj.expiration_date = `Expiration Date is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (
      supplierSimplifiedInvoicesData?.date &&
      supplierSimplifiedInvoicesData?.expiration_date
    ) {
      const start = new Date(supplierSimplifiedInvoicesData.date);
      const end = new Date(supplierSimplifiedInvoicesData.expiration_date);

      if (end < start) {
        errorObj.expiration_date = "Expiration Date must be after Date.";
        error = true;
      }
    }

    if (!supplierSimplifiedInvoicesData.document_set_id) {
      errorObj.document_set_id = `Document Set is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!supplierSimplifiedInvoicesData.supplier_id) {
      errorObj.supplier_id = `Supplier is required.`;
      error = true;
      setBtnLoader(false);
    }

    supplierSimplifiedInvoicesData?.associated_documents?.forEach(
      (tax, index) => {
        let rowError = {};

        if (!tax.associated_id) {
          rowError.associated_id = "Associate is required.";
          error = true;
        }
        if (!tax.value) {
          rowError.value = "Value is required.";
          error = true;
        }

        propertyErrors[index] = rowError;
      },
    );

    let allValid = true;
    supplierSimplifiedInvoicesData?.products.forEach((product, i) => {
      if (!validateProduct(product, i)) {
        allValid = false;
      }
    });

    if (!allValid) {
      toast.error("Product is Required");
      return;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    let data = {
      date: supplierSimplifiedInvoicesData?.date,
      document_set_id: supplierSimplifiedInvoicesData?.document_set_id,
      your_reference: supplierSimplifiedInvoicesData?.your_reference,
      related_documents_notes:
        supplierSimplifiedInvoicesData?.related_documents_notes,
      products: supplierSimplifiedInvoicesData?.products,
      exchange_currency_id:
        supplierSimplifiedInvoicesData?.exchange_currency_id,
      exchange_rate: supplierSimplifiedInvoicesData?.exchange_rate,
      delivery_method_id: supplierSimplifiedInvoicesData?.delivery_method_id,
      delivery_datetime: supplierSimplifiedInvoicesData?.delivery_datetime,
      delivery_departure_city:
        supplierSimplifiedInvoicesData?.delivery_departure_city,
      delivery_departure_zip_code:
        supplierSimplifiedInvoicesData?.delivery_departure_zip_code,
      delivery_departure_country:
        supplierSimplifiedInvoicesData?.delivery_departure_country,
      delivery_destination_address:
        supplierSimplifiedInvoicesData?.delivery_destination_address,
      delivery_destination_city:
        supplierSimplifiedInvoicesData?.delivery_destination_city,
      delivery_destination_zip_code:
        supplierSimplifiedInvoicesData?.delivery_destination_zip_code,
      delivery_destination_country:
        supplierSimplifiedInvoicesData?.delivery_destination_country,
      vehicle_id: supplierSimplifiedInvoicesData?.vehicle_id,
      vehicle_name: supplierSimplifiedInvoicesData?.vehicle_name,
      vehicle_number_plate:
        supplierSimplifiedInvoicesData?.vehicle_number_plate,
      notes: supplierSimplifiedInvoicesData?.notes,
      status: supplierSimplifiedInvoicesData?.status,
      financial_discount: supplierSimplifiedInvoicesData?.financial_discount,
      delivery_departure_address:
        supplierSimplifiedInvoicesData?.delivery_departure_address,
      expiration_date: supplierSimplifiedInvoicesData?.expiration_date,
      maturity_date_id: supplierSimplifiedInvoicesData?.maturity_date_id,
      our_reference: supplierSimplifiedInvoicesData?.our_reference,
      supplier_id: supplierSimplifiedInvoicesData?.supplier_id,
      special_discount: supplierSimplifiedInvoicesData?.special_discount,
      associated_documents:
        supplierSimplifiedInvoicesData?.associated_documents || [],
      associate_document_type:
        supplierSimplifiedInvoicesData?.associate_document_type,
      payments: supplierSimplifiedInvoicesData?.payments,
    };

    let updateData = {
      id: supplierSimplifiedInvoicesData?.id,
      document_id: supplierSimplifiedInvoicesViewData?.document_id,
      date: supplierSimplifiedInvoicesData?.date,
      document_set_id: supplierSimplifiedInvoicesData?.document_set_id,
      your_reference: supplierSimplifiedInvoicesData?.your_reference,
      special_discount: supplierSimplifiedInvoicesData?.special_discount,
      related_documents_notes:
        supplierSimplifiedInvoicesData?.related_documents_notes,
      products: supplierSimplifiedInvoicesData?.products,
      exchange_currency_id:
        supplierSimplifiedInvoicesData?.exchange_currency_id,
      exchange_rate: supplierSimplifiedInvoicesData?.exchange_rate,
      delivery_method_id: supplierSimplifiedInvoicesData?.delivery_method_id,
      delivery_datetime: supplierSimplifiedInvoicesData?.delivery_datetime,
      delivery_departure_city:
        supplierSimplifiedInvoicesData?.delivery_departure_city,
      delivery_departure_zip_code:
        supplierSimplifiedInvoicesData?.delivery_departure_zip_code,
      delivery_departure_country:
        supplierSimplifiedInvoicesData?.delivery_departure_country,
      delivery_destination_address:
        supplierSimplifiedInvoicesData?.delivery_destination_address,
      delivery_destination_city:
        supplierSimplifiedInvoicesData?.delivery_destination_city,
      delivery_destination_zip_code:
        supplierSimplifiedInvoicesData?.delivery_destination_zip_code,
      delivery_destination_country:
        supplierSimplifiedInvoicesData?.delivery_destination_country,
      vehicle_id: supplierSimplifiedInvoicesData?.vehicle_id,
      vehicle_name: supplierSimplifiedInvoicesData?.vehicle_name,
      vehicle_number_plate:
        supplierSimplifiedInvoicesData?.vehicle_number_plate,
      notes: supplierSimplifiedInvoicesData?.notes,
      status: supplierSimplifiedInvoicesData?.status,
      financial_discount: supplierSimplifiedInvoicesData?.financial_discount,
      delivery_departure_address:
        supplierSimplifiedInvoicesData?.delivery_departure_address,
      expiration_date: supplierSimplifiedInvoicesData?.expiration_date,
      maturity_date_id: supplierSimplifiedInvoicesData?.maturity_date_id,
      our_reference: supplierSimplifiedInvoicesData?.our_reference,
      supplier_id: supplierSimplifiedInvoicesData?.supplier_id,
      associated_documents:
        supplierSimplifiedInvoicesData?.associated_documents ||  [],
      associate_document_type:
        supplierSimplifiedInvoicesData?.associate_document_type,
      payments: supplierSimplifiedInvoicesData?.payments,
    };

    if (supplierSimplifiedInvoicesViewData?.id) {
      updateSupplierSimplifiedInvoice(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/supplierSimplifiedInvoices");
          setSupplierSimplifiedInvoicesData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createSupplierSimplifiedInvoice(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/supplierSimplifiedInvoices");
          setSupplierSimplifiedInvoicesData({
            id: "",
            category_id: "",
            type: "",
            name: "",
            summary: "",
            reference: "",
            price: "",
            unit_id: "",
            ean_string: "",
            has_stock: 0,
            stock: "",
            minimum_stock: "",
            pos_favorite: 0,
            at_product_category: "",
            exemption_reason: "",
            taxes: [],
            suppliers: [],
            properties: [],
            warehouse: [],
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">
                  {t("supplierSimplifiedInvoices")}
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmit}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("date")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={supplierSimplifiedInvoicesData.date}
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      date: e.target.value,
                                    });
                                  }}
                                  name="date"
                                  placeholder="Select Date"
                                />
                              </div>
                              {errors.date && (
                                <span className="input-error">
                                  {errors.date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("expirationDate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={
                                    supplierSimplifiedInvoicesData.expiration_date
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      expiration_date: e.target.value,
                                    });
                                  }}
                                  name="expiration_date"
                                  placeholder="Expiration Date"
                                />
                              </div>
                              {errors.expiration_date && (
                                <span className="input-error">
                                  {errors.expiration_date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("maturityDate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={maturityDataList}
                                  value={maturityDataList.find(
                                    (item) =>
                                      item.value ===
                                      supplierSimplifiedInvoicesData.maturity_date_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      maturity_date_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Maturity Date"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("documentSet")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={documentSetList}
                                  value={documentSetList.find(
                                    (item) =>
                                      item.value ===
                                      supplierSimplifiedInvoicesData.document_set_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      document_set_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document Set"}
                                />
                                {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("financial_discount")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={
                                    supplierSimplifiedInvoicesData.financial_discount
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      financial_discount: e.target.value,
                                    });
                                  }}
                                  name="financial_discount"
                                  placeholder="Financial Discount"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("your_reference")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.your_reference
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      your_reference: e.target.value,
                                    });
                                  }}
                                  name="your_reference"
                                  placeholder="Your Reference"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("our_reference")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.our_reference
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      our_reference: e.target.value,
                                    });
                                  }}
                                  name="our_reference"
                                  placeholder="Our Reference"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("supplier")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={suppliersDataList}
                                  value={suppliersDataList.find(
                                    (item) =>
                                      item.value ===
                                      supplierSimplifiedInvoicesData.supplier_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      supplier_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Supplier"}
                                />
                                {errors.supplier_id && (
                                  <span className="input-error">
                                    {errors.supplier_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("special_discount")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={
                                    supplierSimplifiedInvoicesData.special_discount
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      special_discount: e.target.value,
                                    });
                                  }}
                                  name="special_discount"
                                  placeholder="Special Discount"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("related_documents_notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.related_documents_notes
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      related_documents_notes: e.target.value,
                                    });
                                  }}
                                  name="related_documents_notes"
                                  placeholder="Related Documents Notes"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_currency")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={exchangeCurrList}
                                  value={exchangeCurrList.find(
                                    (item) =>
                                      item.value ===
                                      supplierSimplifiedInvoicesData.exchange_currency_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      exchange_currency_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Exchange Currency"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("exchange_rate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={
                                    supplierSimplifiedInvoicesData.exchange_rate
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      exchange_rate: e.target.value,
                                    });
                                  }}
                                  name="exchange_rate"
                                  placeholder="Exchange Rate"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_datetime")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={
                                    supplierSimplifiedInvoicesData.delivery_datetime
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_datetime: e.target.value,
                                    });
                                  }}
                                  name="delivery_datetime"
                                  placeholder="Select Delivery Date"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("deliveryMethod")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={deliveryMethodList}
                                  value={deliveryMethodList.find(
                                    (item) =>
                                      item.value ===
                                      supplierSimplifiedInvoicesData.delivery_method_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_method_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Delivery Method"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_address")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.delivery_departure_address
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_departure_address:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_departure_address"
                                  placeholder="Delivery Departure Address"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_address")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.delivery_destination_address
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_destination_address:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_destination_address"
                                  placeholder="Delivery Destination Address"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_city")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.delivery_departure_city
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_departure_city: e.target.value,
                                    });
                                  }}
                                  name="delivery_departure_city"
                                  placeholder="Delivery Departure city"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_city")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.delivery_destination_city
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_destination_city: e.target.value,
                                    });
                                  }}
                                  name="delivery_destination_city"
                                  placeholder="Delivery Departure city"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_zip_code")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.delivery_departure_zip_code
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_departure_zip_code:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_departure_zip_code"
                                  placeholder="Delivery Departure Zipcode"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_zip_code")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.delivery_destination_zip_code
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_destination_zip_code:
                                        e.target.value,
                                    });
                                  }}
                                  name="delivery_destination_zip_code"
                                  placeholder="Delivery Departure Zipcode"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_destination_country")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={countryList}
                                  value={countryList.find(
                                    (item) =>
                                      item.value ===
                                      supplierSimplifiedInvoicesData.delivery_destination_country,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_destination_country:
                                        selectedOption
                                          ? selectedOption.value
                                          : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Country"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("delivery_departure_country")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={countryList}
                                  value={countryList.find(
                                    (item) =>
                                      item.value ===
                                      supplierSimplifiedInvoicesData.delivery_departure_country,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      delivery_departure_country: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Country"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vehicle")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={vehiclesList}
                                  value={vehiclesList.find(
                                    (item) =>
                                      item.value ===
                                      supplierSimplifiedInvoicesData.vehicle_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      vehicle_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Vehicle"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vehicle_name")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.vehicle_name
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      vehicle_name: e.target.value,
                                    });
                                  }}
                                  name="vehicle_name"
                                  placeholder="Vehicle Name"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vehicle_number_plate")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={
                                    supplierSimplifiedInvoicesData.vehicle_number_plate
                                  }
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      vehicle_number_plate: e.target.value,
                                    });
                                  }}
                                  name="vehicle_number_plate"
                                  placeholder="Vehicle Number Plate"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <textarea
                                  className="form-control input-search"
                                  type="text"
                                  value={supplierSimplifiedInvoicesData.notes}
                                  onChange={(e) => {
                                    setSupplierSimplifiedInvoicesData({
                                      ...supplierSimplifiedInvoicesData,
                                      notes: e.target.value,
                                    });
                                  }}
                                  name="notes"
                                  placeholder="Notes"
                                  rows={3}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("status")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <div className="form-check">
                                  <input
                                    className="my-checkbox-1 form-check-input"
                                    type="checkbox"
                                    checked={
                                      supplierSimplifiedInvoicesData.status ===
                                      1
                                    }
                                    onChange={(e) => {
                                      setSupplierSimplifiedInvoicesData({
                                        ...supplierSimplifiedInvoicesData,
                                        status: e.target.checked ? 1 : 0,
                                      });
                                    }}
                                  />
                                  <label className="form-check-label pl-2">
                                    {t("status")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </FormGroup>
                        </div>
                      </div>

                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{
                            marginTop: "15px",
                            marginBottom: "15px",
                          }}
                        >
                          {" "}
                          <h5>{t("associated_documents")}</h5>
                          <button
                            className="btn btn-primary"
                            onClick={handleAddAssociatedDocuments}
                            type="button"
                          >
                            + {t("add")}
                          </button>
                          <div className="col-md-3">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("associate_document_type")}
                              </Label>
                              <Select
                                className="my-select-v"
                                options={invoiceType}
                                value={invoiceType.find(
                                  (item) =>
                                    item.value ===
                                    supplierSimplifiedInvoicesData.associate_document_type,
                                )}
                                onChange={(selectedOption) => {
                                  setSupplierSimplifiedInvoicesData({
                                    ...supplierSimplifiedInvoicesData,
                                    associate_document_type: selectedOption
                                      ? selectedOption.value
                                      : "",
                                  });
                                }}
                                isSearchable={true}
                                isClearable={true}
                                placeholder={"Select Document type"}
                              />
                            </FormGroup>
                          </div>
                        </div>

                        {supplierSimplifiedInvoicesData?.associated_documents
                          ?.length > 0 ? (
                          <div
                            className="row justify-content-start"
                            style={{
                              maxHeight: "300px",
                              overflowY: "auto",
                            }}
                          >
                            {supplierSimplifiedInvoicesData?.associated_documents?.map(
                              (tax, index) => (
                                <div className="col-md-6">
                                  <div className="fileupload-content px-4">
                                    <div
                                      className="row justify-content-start align-items-center mb-2"
                                      key={index}
                                    >
                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("associated_documents")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <Select
                                                className="my-select-v"
                                                options={assocDataList}
                                                value={
                                                  assocDataList.find(
                                                    (item) =>
                                                      item.value ===
                                                      tax.associated_id,
                                                  ) || null
                                                }
                                                onChange={(selectedOption) => {
                                                  handleChangeAssociatedDocuments(
                                                    index,
                                                    "associated_id",
                                                    selectedOption
                                                      ? selectedOption.value
                                                      : "",
                                                  );
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder={"Select Associate"}
                                              />
                                              {propertyErrors[index]
                                                ?.associated_id && (
                                                <small className="text-danger">
                                                  {
                                                    propertyErrors[index]
                                                      .associated_id
                                                  }
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("value")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="number"
                                                value={tax.value}
                                                onChange={(e) =>
                                                  handleChangeAssociatedDocuments(
                                                    index,
                                                    "value",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Value"
                                              />
                                              {propertyErrors[index]?.value && (
                                                <small className="text-danger">
                                                  {propertyErrors[index].value}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="d-flex align-items-center">
                                        <button
                                          className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                          onClick={() =>
                                            handleRemoveAssociatedDocuments(
                                              index,
                                              tax,
                                            )
                                          }
                                          type="button"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        ) : (
                          <p className="text-muted">
                            No Associated documents list added.
                          </p>
                        )}
                      </div>

                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{
                            marginTop: "15px",
                            marginBottom: "15px",
                          }}
                        >
                          {" "}
                          <h5>{t("payments")}</h5>
                          <button
                            className="btn btn-primary"
                            onClick={handleAddPayments}
                            type="button"
                          >
                            + {t("add")}
                          </button>
                        </div>

                        {supplierSimplifiedInvoicesData?.payments?.length >
                        0 ? (
                          <div
                            className="row justify-content-start"
                            style={{
                              maxHeight: "300px",
                              overflowY: "auto",
                            }}
                          >
                            {supplierSimplifiedInvoicesData?.payments?.map(
                              (tax, index) => (
                                <div className="col-md-6">
                                  <div className="fileupload-content px-4">
                                    <div
                                      className="row justify-content-start align-items-center mb-2"
                                      key={index}
                                    >
                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("payments")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <Select
                                                className="my-select-v"
                                                options={paymentList}
                                                value={
                                                  paymentList.find(
                                                    (item) =>
                                                      item.value ===
                                                      tax.payment_method_id,
                                                  ) || null
                                                }
                                                onChange={(selectedOption) => {
                                                  handleChangePayments(
                                                    index,
                                                    "payment_method_id",
                                                    selectedOption
                                                      ? selectedOption.value
                                                      : "",
                                                  );
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder={"Select Payment"}
                                              />
                                              {paymentErrors[index]
                                                ?.payment_method_id && (
                                                <small className="text-danger">
                                                  {
                                                    paymentErrors[index]
                                                      .payment_method_id
                                                  }
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("date")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="date"
                                                value={tax.date}
                                                onChange={(e) =>
                                                  handleChangePayments(
                                                    index,
                                                    "date",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Date"
                                              />
                                              {paymentErrors[index]?.date && (
                                                <small className="text-danger">
                                                  {paymentErrors[index].date}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("value")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="number"
                                                value={tax.value}
                                                onChange={(e) =>
                                                  handleChangePayments(
                                                    index,
                                                    "value",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Value"
                                              />
                                              {paymentErrors[index]?.value && (
                                                <small className="text-danger">
                                                  {paymentErrors[index].value}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("notes")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <textarea
                                                className="form-control input-search"
                                                type="text"
                                                value={tax.notes}
                                                onChange={(e) =>
                                                  handleChangePayments(
                                                    index,
                                                    "notes",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Notes"
                                              />
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="d-flex align-items-center">
                                        <button
                                          className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                          onClick={() =>
                                            handleRemovePayments(index, tax)
                                          }
                                          type="button"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        ) : (
                          <p className="text-muted">No Payment list added.</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("products")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddProduct}
                              type="button"
                            >
                              + {t("add_product")}
                            </button>
                          </div>

                          {supplierSimplifiedInvoicesData?.products?.map(
                            (product, i) => (
                              <div key={i} className="card p-3 mb-3">
                                <h5>Product {i + 1}</h5>
                                <div className="row">
                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("product")}
                                      </Label>
                                      <Select
                                        className="my-select-v"
                                        options={productList}
                                        value={productList.find(
                                          (item) =>
                                            item.value ===
                                            String(
                                              supplierSimplifiedInvoicesData
                                                .products[i].product_id,
                                            ),
                                        )}
                                        onChange={(selectedOption) => {
                                          let list = [
                                            ...supplierSimplifiedInvoicesData.products,
                                          ];
                                          list[i].product_id = selectedOption
                                            ? selectedOption.value
                                            : null;
                                          setSupplierSimplifiedInvoicesData({
                                            ...supplierSimplifiedInvoicesData,
                                            products: list,
                                          });
                                          validateProduct(list[i], i); // validation
                                          setSelectedProduct(selectedOption);
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Product"}
                                      />
                                      {errorsPro[i]?.product_id && (
                                        <small className="text-danger">
                                          {errorsPro[i].product_id}
                                        </small>
                                      )}
                                    </FormGroup>
                                  </div>
                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("name")}
                                      </Label>
                                      <input
                                        type="text"
                                        className="form-control mb-2"
                                        placeholder="Name"
                                        value={product.name}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierSimplifiedInvoicesData.products,
                                          ];
                                          list[i].name = e.target.value;
                                          setSupplierSimplifiedInvoicesData({
                                            ...supplierSimplifiedInvoicesData,
                                            products: list,
                                          });
                                          validateProduct(list[i], i); //validation
                                        }}
                                      />
                                      {errorsPro[i]?.name && (
                                        <small className="text-danger">
                                          {errorsPro[i].name}
                                        </small>
                                      )}
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("summary")}
                                      </Label>
                                      <input
                                        type="text"
                                        className="form-control mb-2"
                                        placeholder="Summary"
                                        value={product.summary}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierSimplifiedInvoicesData.products,
                                          ];
                                          list[i].summary = e.target.value;
                                          setSupplierSimplifiedInvoicesData({
                                            ...supplierSimplifiedInvoicesData,
                                            products: list,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("quantity")}
                                      </Label>
                                      <input
                                        type="number"
                                        className="form-control mb-2"
                                        placeholder="Quantity"
                                        value={product.qty}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierSimplifiedInvoicesData.products,
                                          ];
                                          list[i].qty = parseFloat(
                                            e.target.value,
                                          );
                                          setSupplierSimplifiedInvoicesData({
                                            ...supplierSimplifiedInvoicesData,
                                            products: list,
                                          });
                                          validateProduct(list[i], i);
                                        }}
                                      />
                                      {errorsPro[i]?.qty && (
                                        <small className="text-danger">
                                          {errorsPro[i].qty}
                                        </small>
                                      )}
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("price")}
                                      </Label>
                                      <input
                                        type="number"
                                        className="form-control mb-2"
                                        placeholder="Price"
                                        value={product.price}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierSimplifiedInvoicesData.products,
                                          ];
                                          list[i].price = parseFloat(
                                            e.target.value,
                                          );
                                          setSupplierSimplifiedInvoicesData({
                                            ...supplierSimplifiedInvoicesData,
                                            products: list,
                                          });
                                          validateProduct(list[i], i);
                                        }}
                                      />
                                      {errorsPro[i]?.price && (
                                        <small className="text-danger">
                                          {errorsPro[i].price}
                                        </small>
                                      )}
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("discount")}
                                      </Label>
                                      <input
                                        type="number"
                                        className="form-control mb-2"
                                        placeholder="Discount"
                                        value={product.discount}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierSimplifiedInvoicesData.products,
                                          ];
                                          list[i].discount = parseFloat(
                                            e.target.value,
                                          );
                                          setSupplierSimplifiedInvoicesData({
                                            ...supplierSimplifiedInvoicesData,
                                            products: list,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </div>
                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("deduction")}
                                      </Label>
                                      <Select
                                        className="my-select-v"
                                        options={deductionList}
                                        value={deductionList.find(
                                          (item) =>
                                            item.value ===
                                            supplierSimplifiedInvoicesData
                                              .products[i].deduction_id,
                                        )}
                                        onChange={(selectedOption) => {
                                          let list = [
                                            ...supplierSimplifiedInvoicesData.products,
                                          ];
                                          list[i].deduction_id = selectedOption
                                            ? selectedOption.value
                                            : null;
                                          setSupplierSimplifiedInvoicesData({
                                            ...supplierSimplifiedInvoicesData,
                                            products: list,
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder={"Select Deduction"}
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("order")}
                                      </Label>
                                      <input
                                        type="number"
                                        className="form-control mb-2"
                                        placeholder="Order"
                                        value={product.order}
                                        onChange={(e) => {
                                          let list = [
                                            ...supplierSimplifiedInvoicesData.products,
                                          ];
                                          list[i].order = parseFloat(
                                            e.target.value,
                                          );
                                          setSupplierSimplifiedInvoicesData({
                                            ...supplierSimplifiedInvoicesData,
                                            products: list,
                                          });
                                        }}
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        {t("exemption_reason")}
                                      </Label>
                                      <div className="col-xl-12">
                                        <div className="input-div">
                                          <Select
                                            className="my-select-v"
                                            options={exemptionList}
                                            value={exemptionList.find(
                                              (item) =>
                                                item.value ===
                                                supplierSimplifiedInvoicesData
                                                  .products[i].exemption_reason,
                                            )}
                                            onChange={(selectedOption) => {
                                              let list = [
                                                ...supplierSimplifiedInvoicesData.products,
                                              ];
                                              list[i].exemption_reason =
                                                selectedOption
                                                  ? selectedOption.value
                                                  : null;
                                              setSupplierSimplifiedInvoicesData(
                                                {
                                                  ...supplierSimplifiedInvoicesData,
                                                  products: list,
                                                },
                                              );
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder={
                                              "Select Exemption Reason"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-3"></div>

                                  <div className="col-md-3"></div>
                                  <div className="col-md-3"></div>

                                  <div className="row">
                                    <div
                                      className="col-md-12"
                                      style={{
                                        marginTop: "15px",
                                        marginBottom: "15px",
                                      }}
                                    >
                                      {" "}
                                      <h5>{t("tax")}</h5>
                                      <button
                                        className="btn btn-primary"
                                        onClick={(e) => handleAddTax(e, i)}
                                        type="button"
                                      >
                                        + {t("add_tax")}
                                      </button>
                                    </div>
                                    {product?.taxes?.length > 0 ? (
                                      <div
                                        className="row justify-content-start"
                                        style={{
                                          maxHeight: "300px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {product?.taxes?.map((prop, j) => (
                                          <div className="col-md-6">
                                            <div className="fileupload-content px-4">
                                              <div
                                                className="row justify-content-start align-items-center mb-2"
                                                key={j}
                                              >
                                                <div className="col-md-6">
                                                  <FormGroup>
                                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                      {t("tax")}
                                                    </Label>
                                                    <Select
                                                      className="my-select-v"
                                                      options={taxDataList}
                                                      value={taxDataList.find(
                                                        (item) =>
                                                          item.value ===
                                                          String(
                                                            supplierSimplifiedInvoicesData
                                                              .products[i]
                                                              .taxes[j].tax_id,
                                                          ),
                                                      )}
                                                      onChange={(
                                                        selectedOption,
                                                      ) => {
                                                        let list = [
                                                          ...supplierSimplifiedInvoicesData.products,
                                                        ];
                                                        list[i].taxes[
                                                          j
                                                        ].tax_id =
                                                          selectedOption
                                                            ? selectedOption.value
                                                            : null;
                                                        setSupplierSimplifiedInvoicesData(
                                                          {
                                                            ...supplierSimplifiedInvoicesData,
                                                            products: list,
                                                          },
                                                        );
                                                      }}
                                                      isSearchable={true}
                                                      isClearable={true}
                                                      placeholder={"Select Tax"}
                                                    />
                                                  </FormGroup>
                                                </div>

                                                <div className="col-md-6">
                                                  <FormGroup>
                                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                      {t("value")}
                                                    </Label>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Value"
                                                      value={prop.value}
                                                      onChange={(e) => {
                                                        let list = [
                                                          ...supplierSimplifiedInvoicesData.products,
                                                        ];
                                                        list[i].properties[
                                                          j
                                                        ].value =
                                                          e.target.value;
                                                        setSupplierSimplifiedInvoicesData(
                                                          {
                                                            ...supplierSimplifiedInvoicesData,
                                                            products: list,
                                                          },
                                                        );
                                                      }}
                                                    />
                                                  </FormGroup>
                                                </div>
                                                <div className="col-md-6">
                                                  <FormGroup>
                                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                      {t("order")}
                                                    </Label>
                                                    <input
                                                      type="Number"
                                                      className="form-control"
                                                      placeholder="Order"
                                                      value={prop.order}
                                                      onChange={(e) => {
                                                        let list = [
                                                          ...supplierSimplifiedInvoicesData.products,
                                                        ];
                                                        list[i].taxes[j].order =
                                                          e.target.value;
                                                        setSupplierSimplifiedInvoicesData(
                                                          {
                                                            ...supplierSimplifiedInvoicesData,
                                                            products: list,
                                                          },
                                                        );
                                                      }}
                                                    />
                                                  </FormGroup>
                                                </div>

                                                <div className="col-md-4 d-flex align-item-center">
                                                  <FormGroup>
                                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                                      {t("cumulative")}
                                                    </Label>
                                                    <div className="col-xl-12">
                                                      <div className="input-div">
                                                        <div className="form-check">
                                                          <input
                                                            className="my-checkbox-1 form-check-input"
                                                            type="checkbox"
                                                            checked={
                                                              prop.cumulative ===
                                                              1
                                                            }
                                                            onChange={(e) => {
                                                              let list = [
                                                                ...supplierSimplifiedInvoicesData.products,
                                                              ];
                                                              list[i].taxes[
                                                                j
                                                              ].cumulative = e
                                                                .target.checked
                                                                ? 1
                                                                : 0;
                                                              setSupplierSimplifiedInvoicesData(
                                                                {
                                                                  ...supplierSimplifiedInvoicesData,
                                                                  products:
                                                                    list,
                                                                },
                                                              );
                                                            }}
                                                          />
                                                          <label className="form-check-label pl-2">
                                                            {t("Cumulative")}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </FormGroup>
                                                </div>
                                                <div className="d-flex align-item-center">
                                                  <button
                                                    className="btn btn-danger"
                                                    onClick={(e) =>
                                                      handleRemoveTax(e, i, j)
                                                    }
                                                  >
                                                    <i className="bi bi-trash"></i>
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <p className="text-muted">
                                        No tax list added.
                                      </p>
                                    )}
                                  </div>
                                </div>

                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={(e) => handleRemoveProduct(e, i)}
                                >
                                  <i className="bi bi-trash"></i>
                                </button>

                                <div className="row d-none">
                                  <div
                                    className="col-md-12"
                                    style={{
                                      marginTop: "15px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    <h5>{t("child_products")}</h5>
                                    <button
                                      className="btn btn-primary"
                                      onClick={(e) =>
                                        handleAddChildProduct(e, i)
                                      }
                                      type="button"
                                    >
                                      + {t("add_child_product")}
                                    </button>
                                  </div>

                                  {product?.child_products?.map((child, k) => (
                                    <div
                                      key={k}
                                      className="card p-2 mb-2 border"
                                    >
                                      <h6>Child Product {k + 1}</h6>

                                      <div className="row">
                                        <div className="col-md-3">
                                          <FormGroup>
                                            <Label>{t("child_name")}</Label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={child.name}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[k].name =
                                                  e.target.value;
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                            />
                                          </FormGroup>
                                        </div>
                                        <div className="col-md-3">
                                          <FormGroup>
                                            <Label>{t("summary")}</Label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={child.summary}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[
                                                  k
                                                ].summary = e.target.value;
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                            />
                                          </FormGroup>
                                        </div>
                                        <div className="col-md-3">
                                          <FormGroup>
                                            <Label>{t("quantity")}</Label>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={child.qty}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[k].qty =
                                                  parseFloat(e.target.value);
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                            />
                                          </FormGroup>
                                        </div>
                                        <div className="col-md-3">
                                          <FormGroup>
                                            <Label>{t("price")}</Label>
                                            <input
                                              type="number"
                                              className="form-control"
                                              value={child.price}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[
                                                  k
                                                ].price = parseFloat(
                                                  e.target.value,
                                                );
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                            />
                                          </FormGroup>
                                        </div>
                                      </div>

                                      {/* Properties Section for child */}
                                      <div className="row mt-2">
                                        <h6>{t("properties")}</h6>
                                        <button
                                          className="btn btn-sm btn-primary"
                                          onClick={(e) =>
                                            handleAddChildProperty(e, i, k)
                                          }
                                          type="button"
                                        >
                                          + {t("add_property")}
                                        </button>
                                        {child?.properties?.map((prop, j) => (
                                          <div
                                            key={j}
                                            className="d-flex gap-2 mb-2"
                                          >
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Title"
                                              value={prop.title}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[
                                                  k
                                                ].properties[j].title =
                                                  e.target.value;
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                            />
                                            <input
                                              type="text"
                                              className="form-control"
                                              placeholder="Value"
                                              value={prop.value}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[
                                                  k
                                                ].properties[j].value =
                                                  e.target.value;
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                            />
                                          </div>
                                        ))}
                                      </div>

                                      {/* Taxes Section for child */}
                                      <div className="row mt-2">
                                        <h6>{t("taxes")}</h6>
                                        <button
                                          className="btn btn-sm btn-primary"
                                          onClick={(e) =>
                                            handleAddChildTax(e, i, k)
                                          }
                                          type="button"
                                        >
                                          + {t("add_tax")}
                                        </button>
                                        {child?.taxes?.map((tax, j) => (
                                          <div
                                            key={j}
                                            className="d-flex gap-2 mb-2"
                                          >
                                            <Select
                                              className="my-select-v"
                                              options={taxDataList}
                                              value={taxDataList.find(
                                                (item) =>
                                                  item.value === tax.tax_id,
                                              )}
                                              onChange={(selectedOption) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[k].taxes[
                                                  j
                                                ].tax_id = selectedOption
                                                  ? selectedOption.value
                                                  : null;
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                              isSearchable
                                              isClearable
                                              placeholder="Select Tax"
                                            />
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="Value"
                                              value={tax.value}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[k].taxes[
                                                  j
                                                ].value = parseFloat(
                                                  e.target.value,
                                                );
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                            />
                                            <input
                                              type="number"
                                              className="form-control"
                                              placeholder="Order"
                                              value={tax.order}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[k].taxes[
                                                  j
                                                ].order = parseFloat(
                                                  e.target.value,
                                                );
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                            />
                                            <input
                                              type="checkbox"
                                              checked={tax.cumulative === 1}
                                              onChange={(e) => {
                                                let list = [
                                                  ...supplierSimplifiedInvoicesData.products,
                                                ];
                                                list[i].child_products[k].taxes[
                                                  j
                                                ].cumulative = e.target.checked
                                                  ? 1
                                                  : 0;
                                                setSupplierSimplifiedInvoicesData(
                                                  {
                                                    ...supplierSimplifiedInvoicesData,
                                                    products: list,
                                                  },
                                                );
                                              }}
                                            />
                                          </div>
                                        ))}
                                      </div>

                                      {/* Remove child button */}
                                      <button
                                        className="btn btn-danger mt-2"
                                        onClick={(e) =>
                                          handleRemoveChildProduct(e, i, k)
                                        }
                                      >
                                        <i className="bi bi-trash"></i>{" "}
                                        {t("remove_child_product")}
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            ),
                          )}
                        </div>

                        <div className="row">
                          <div className="col ms-2">
                            <button
                              type="button"
                              className="back-btn"
                              onClick={() =>
                                navigate("/supplierSimplifiedInvoices")
                              }
                            >
                              <i className="bi bi-arrow-left"> </i> {t("back")}
                            </button>
                          </div>
                          <div className="col">
                            <div className="d-flex justify-content-end nxt-btn">
                              {btnLoader === true ? (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Loading...
                                </button>
                              ) : (
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  {t("submit")} <i className="bi bi-check2"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddSupplierSimplifiedInvoices;
